import React, { useEffect, useState } from 'react';
import { ReactSession } from "react-client-session";
import Modal from 'react-bootstrap/Modal';
import msg from '../Tools/MsgUtils';
import ModalCargando from '../utilsComponentes/ModalCargando';
const server = process.env.REACT_APP_SERVER;

function TemperaturaFreidoras() {
    const [sucursales, setSucursales] = useState([]);
    const [sucursal, setSucursal] = useState();
    const [regional, setRegional] = useState(ReactSession.get("regional"));
    const [listaFreidoras,setListaFreidoras] = useState([]);
    const [modalEditar,setModalEditar] = useState(false);
    const [freidoraSelec,setFreidoraSelec] = useState({});
    const [tiempoSeg,setTiempoSeg] = useState(0);
    const [actualizar,setActualizar] = useState(0); 
    const [cargarLoader,setCagarLoader] = useState(false);
    const obtenerInformacion = () => {
        setCagarLoader(true);
        var info = sucursales.filter(item => item.ID_SUCURSAL == sucursal);
        fetch(`${server}/moduloSistemas/getFreidoras`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                info: { ...info[0], idUsuario: ReactSession.get("idSession") }
            })
        })
            .then(res => res.json())
            .then(data => {
                if(data.ok){
                    setListaFreidoras(data.ok);
                    setCagarLoader(false);
                }else{
                    msg.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }
    const desconectarSucursalAnterior = (info) => {
        fetch(`${server}/dbConectar/desconectar`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                info: { ...info[0], idUsuario: ReactSession.get("idSession") }
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
            })
            .catch(err => console.log(err));
    }
    const cambiarSucursal = (e) => {
        if (sucursal !== undefined) {
            desconectarSucursalAnterior(sucursales.filter(item => item.ID_SUCURSAL == sucursal));
        }
        setSucursal(e.target.value);
        console.log(sucursal);
        console.log(e.target.value);
        var info = sucursales.filter(item => item.ID_SUCURSAL == e.target.value);
        fetch(`${server}/dbConectar/conectar`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                info: { ...info[0], idUsuario: ReactSession.get("idSession") }
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                setListaFreidoras([]);
            })
            .catch(err => console.log(err));
    }
    const editarItem=(item)=>{
        setFreidoraSelec(item);
        setTiempoSeg(item.TIEMPO);
        setModalEditar(true);
    }
    const gardarInformacion = (tipo)=>{
        var info = sucursales.filter(item => item.ID_SUCURSAL == sucursal);
        fetch(`${server}/moduloSistemas/updateFreidora`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                info: { ...info[0], ...freidoraSelec,tiempoSeg,idUsuario: ReactSession.get("idSession"),tipo}
            })
        })
            .then(res => res.json())
            .then(data => {
                if(data.ok){
                    setActualizar(actualizar+1);
                    setModalEditar(false);
                    msg.msgCorrecto(data.ok);
                }else{
                    msg.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }
    const cambiarRegional = (e)=>{
        setRegional(e.target.value);
        setListaFreidoras([]);
    }
    useEffect(()=>{
        if(listaFreidoras.length!=0){
            obtenerInformacion();
        }
    },[actualizar])
    useEffect(() => {
        fetch(`${server}/sqlComun/getSucursales`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    msg.msgError(data.error);
                } else {
                    setSucursales(data.ok);
                }
            })
            .catch(err => console.log(err));
    }, [regional]);
    return (
        <div>
            <div className='container-fluid bg-dark bg-gradient '>
                <div className='row g-1'>
                    <div className='col-2'>
                        <div className="input-group my-auto" style={{ height: "30px" }}>
                            <span className="input-group-text bg-dark bg-gradient text-light" style={{ height: "30px" }}>Regional</span>
                            <select className="form-select form-sm-select btn-sm btn-secondary " 
                                style={{ height: "30px" }} value={regional} onChange={cambiarRegional}>
                                <option value='990'>CBBA</option>
                                <option value='991'>SCRZ</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-2'>
                        <div className="input-group my-auto" style={{ height: "30px" }}>
                            <span className="input-group-text bg-dark bg-gradient text-light" style={{ height: "30px" }}>{`Sucursal`}</span>
                            <select className="form-select form-sm-select btn-sm btn-secondary " 
                                style={{ height: "30px" }} value={sucursal} onChange={cambiarSucursal}>
                                <option value=''>--ninguno--</option>
                                {sucursales.map((item, i) => {
                                    return <option value={item.ID_SUCURSAL} key={item.ID_SUCURSAL}>{item.SUCURSAL}</option>
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col-1 '>
                        <button className='btn btn-sm btn-light' onClick={obtenerInformacion}>
                            <i className="fa-solid fa-link"></i><span>Conectar</span>
                        </button>
                    </div>
                </div>
            </div>
            {cargarLoader===false&&
            <div className='table-responsive container-fluid'>
                <table className="table table-sm">
                    <thead>
                        <tr>
                            <th scope="col">Id Freidora</th>
                            <th scope="col">Tipo</th>
                            <th scope="col">Tiempo seg</th>
                            <th scope="col">Cant Ini</th>
                            <th scope="col">Cant Fin</th>
                            <th scope='col'>Editar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listaFreidoras.map((item,index)=>{
                            return(
                                <tr key={index}>
                                    <th>{item.ID_FREIDORA}</th>
                                    <td>{item.TIPO}</td>
                                    <td>{item.TIEMPO}</td>
                                    <td>{item.CANTIDAD_DESDE}</td>
                                    <td>{item.CANTIDAD_HASTA}</td>
                                    <td>
                                        <button className='btn btn-sm btn-warning' onClick={()=>editarItem(item)}>
                                            <i className="fa-solid fa-pencil fa-xl"></i>
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>}
            <Modal show={modalEditar} onHide={() => setModalEditar(false)}
                //size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        <div className='text-light'>{`Editar Freidora N° ${freidoraSelec.ID_FREIDORA}`}</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='container-fluid'>
                        <div className='text-center text-light fw-bold'>{`TIPO: ${freidoraSelec.TIPO}`}</div>
                        <div className='text-center text-light fw-bold'>{`Cantidad Inicio: ${freidoraSelec.CANTIDAD_DESDE}`}</div>
                        <div className='text-center text-light fw-bold'>{`Cantidad Final: ${freidoraSelec.CANTIDAD_HASTA}`}</div>
                        <div className="input-group my-auto" style={{ height: "25px" }}>
                            <span className="input-group-text bg-secondary bg-gradient text-light" style={{ height: "25px" }}>{`Tiempo [seg]`}</span>
                            <input type="text" className="form-control"
                                maxLength="30"
                                placeholder='Titulo de Noticia' style={{ height: "25px" }}
                                value={tiempoSeg} onChange={(e) => setTiempoSeg(e.target.value)} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer  bsPrefix='modal-footer m-0 p-0'>
                    {freidoraSelec.TIPO!=='PAPA'&&
                        <button className='btn btn-sm btn-success' onClick={()=>gardarInformacion(0)}>
                            <i className="fa-solid fa-floppy-disk"></i> A los Iguales
                        </button>
                    }
                    <button className='btn btn-sm btn-success' onClick={()=>gardarInformacion(1)}><i className="fa-solid fa-floppy-disk"></i> Guardar</button>
                </Modal.Footer>
            </Modal>
            <ModalCargando show={cargarLoader}/>
        </div>
    )
}

export default TemperaturaFreidoras
